import React from "react";

import ArrowRight from "./ArrowRight";

/**
 * "Bereits ein Konto? Anmelden →" — shown below the CTA on steps 1–3.
 */
const AlreadyHaveAccount = () => (
    <p className="registration-login-hint">
        Bereits ein Konto?{" "}
        <a href={"/login"} data-cy="registration-anmelden-link">
            Anmelden <ArrowRight size={12} />
        </a>
    </p>
);

export default AlreadyHaveAccount;
